export function getValueFromInput(id:string):any {
    let ele :any = document.getElementById(id)
    return ele.value
}
export function getValueFromInputCheck(id:string):boolean {
    let ele :any = document.getElementById(id)
    return ele.checked
}

export function getTextInElementId(id:string):string {
    let ele :any = document.getElementById(id)
    return ele.innerText
}

export function defineTextInElementId(id:string, value:string) {
    let ele :any = document.getElementById(id)
    ele.innerHTML = value
}

export function defineValueInInput(id:string, value:any) {
    let ele :any = document.getElementById(id)
    ele.value = value
}

export function defineCheckBoxInput(id:string, value:boolean) {
    let ele :any = document.getElementById(id)
    ele.checked = value
}

export function showInputErrorMsg(id:string) { 
    let ele: any = document.getElementById(id)
    ele.nextElementSibling.style.display = "block";
}

export function disabledInput(id:string, value:boolean) {
    let ele :any = document.getElementById(id)
    ele.disabled = value
}

export function checkInput(id:string, value:boolean) {
    let ele :any = document.getElementById(id)
    ele.checked = value
}

export function existInput(id:string) {
    let ele :any = document.getElementById(id)
    return ele
}

export function getElementFromId(id:string):any {
    let ele :any = document.getElementById(id)
    return ele
}
